import { LongTextField } from "ra-friendsofbabba";
import React from "react";

const LongText = ({ value, maxWidth = 400 }) => (
  <LongTextField
    record={{ value }}
    source="value"
    maxWidth={maxWidth}
    variant="body2"
    component="span"
  />
);

export default LongText;
